export enum MasterDataMenus {
  Investments = "Investments",
  Portfolios = "Portfolios",
  SelectionSet = "Selection Sets",
  Attributes = "Attributes",
  Indexes = "Indexes",
  PeerGroups = "Peer Groups",
  Investors = "Investors",
  CalculationSet = "Calculation Sets",
}

export enum UniverseAnalyticsMenus {
  Currencies = "Currencies",
  FilterFields = "Filter Fields",
  FilterValues = "Filter Values",
  MeasurementDate = "Measurement Dates",
}
